import StateCommunications from '@/models/state/StateCommunications'
import StateBuildings from '@/models/state/StateBuildings'
import StateOffers from '@/models/state/StateOffers'
import StateLoans from '@/models/state/StateLoans'
import StateTools from '@/models/state/StateTools'
import StateStuffs from '@/models/state/StateStuffs'
import StateAvailableStaff from '@/models/state/StateAvailableStaff'
import StateStaff from '@/models/state/StateStaff'
import StateOldStaff from '@/models/state/StateOldStaff'
import StateAvailableContracts from '@/models/state/StateAvailableContracts'
import StateContracts from '@/models/state/StateContracts'
import StateOldContracts from '@/models/state/StateOldContracts'
import StateInvoices from '@/models/state/StateInvoices'
import StateSupplier from '@/models/state/StateSupplier'
import StateTrainings from '@/models/state/StateTrainings'
import StateScores from '@/models/state/StateScores'
import StateResults from '@/models/state/StateResults'

/**
 * Registre des domaines d'un State.
 * La clé est le nom utilisé côté application (props de vues, agrégats, `subToData`).
 */
export const STATE_DOMAINS = {
  communications: StateCommunications,
  buildings: StateBuildings,
  offers: StateOffers,
  loans: StateLoans,
  tools: StateTools,
  stuffs: StateStuffs,
  availableStaff: StateAvailableStaff,
  staff: StateStaff,
  oldStaff: StateOldStaff,
  availableContracts: StateAvailableContracts,
  contracts: StateContracts,
  oldContracts: StateOldContracts,
  invoices: StateInvoices,
  supplier: StateSupplier,
  trainings: StateTrainings,
  scores: StateScores,
  results: StateResults,
}

export const STATE_DOMAIN_KEYS = Object.keys(STATE_DOMAINS)

export const STATE_DOMAIN_CLASSES = Object.values(STATE_DOMAINS)

export default STATE_DOMAINS
